import translate from "./translate.js";

export default function (doc) {
  return {
    id: doc.id,
    title: translate(doc.get("title")),
  };
}
